<div class="dialog-header">
  <span class="dialog-title">Edit Organization</span>
  <span class="material-symbols-outlined dialog-close close-button" (click)="dialogRef.close()" type="button">close</span>
</div>

<div class="dialog-body">
  <div class="dialog-left">
    <!-- Organization Name -->
    <div class="field">
      <input type="text" [(ngModel)]="data.friendlyName" #orgNameCtrl="ngModel" required placeholder=" ">
      <label>Organization Name</label>
    </div>

    <!-- Logo -->
    <div class="logo-section">
      <span class="field-label">Upload Organization's Logo <span class="field-label--muted">(Optional)</span></span>
      @if (!logoUrl) {
      <button class="btn btn--outlined" type="button" (click)="logoInput.click()">Upload Logo</button>
      }
      <input #logoInput type="file" accept="image/*" (change)="uploadLogo($event.target.files)" style="display: none;">
      @if (logoUrl) {
      <div class="logo-preview">
        <img class="logo-preview__img" [src]="logoUrl">
        <div class="logo-preview__actions" width="100%">
          <button style="width: 100%;" class="btn btn--outlined" type="button" (click)="logoInput.click()">Change Logo</button>
        </div>
        <div width="100%">
          <button style="width: 100%;" class="btn btn--text" type="button" (click)="logoUrl = ''">Remove Logo</button>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="dialog-right">
    <div class="dialog-cols">

      <!-- Left column -->
      <div class="dialog-col">

        <!-- Default Manual Reviewer -->
        <div class="form-card">
          <div class="form-card__header">
            <span class="form-card__title">Default Manual Reviewer</span>
            <span class="form-card__sub">When our AI detects anomalies or concerning line items within a statement,
              choose one of the following:</span>
          </div>
          <div class="form-card__body">
            <label class="radio-option">
              <span class="radio-option__label">
                <input type="radio" [(ngModel)]="defaultReviewer" value="admin">
                Audit Admin Manual Review
              </span>
              <span class="radio-option__hint">Have a Audit team member review the statement more thoroughly</span>
            </label>
            <label class="radio-option">
              <span class="radio-option__label">
                <input type="radio" [(ngModel)]="defaultReviewer" value="self">
                Self-Service Manual Review
              </span>
              <span class="radio-option__hint">Have the ability to review the statement yourself</span>
            </label>
          </div>
        </div>

        <!-- Organization Buy Rates -->
        <div class="form-card">
          <div class="form-card__header">
            <span class="form-card__title">Organization Buy Rates</span>
          </div>
          <div class="form-card__body">
            <div class="field">
              <input type="number" step="0.00001" [(ngModel)]="transRatePercent" [ngModelOptions]="{standalone: true}"
                [min]="0" placeholder=" ">
              <label>Percentage Cost Per Transaction</label>
              <span class="field__suffix">%</span>
            </div>
            <div class="field">
              <span class="field__prefix">$</span>
              <input currencyMask [(ngModel)]="data.buyRates.costPerTrans" [options]="{precision: 4}" [min]="0"
                placeholder=" ">
              <label>Cost Per Transaction</label>
            </div>
            <div class="field">
              <span class="field__prefix">$</span>
              <input currencyMask [(ngModel)]="data.buyRates.fixedMonthlyFeeTotal" [options]="{precision: 4}" [min]="0"
                placeholder=" ">
              <label>Fixed Additional Monthly Fees Total</label>
            </div>
            <div class="field">
              <input type="number" step="0.00001" [(ngModel)]="overCostPercent" [ngModelOptions]="{standalone: true}"
                [min]="0" placeholder=" ">
              <label>Profit Percentage Over Cost</label>
              <span class="field__suffix">%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right column -->
      <div class="dialog-col">

        <!-- Default User Markup -->
        <div class="form-card">
          <div class="form-card__header">
            <span class="form-card__title">Default User Markup</span>
            <span class="form-card__sub">Values will be combined with Buy Rate values to calculate the Total
              Markup.</span>
          </div>
          <div class="form-card__body">
            <div class="field">
              <input type="number" step="0.00001" [(ngModel)]="muTransRatePercent" [ngModelOptions]="{standalone: true}"
                [min]="0" placeholder=" ">
              <label>Percentage Cost Per Transaction</label>
              <span class="field__suffix">%</span>
            </div>
            <div class="field">
              <span class="field__prefix">$</span>
              <input currencyMask [(ngModel)]="data.defaultUserMarkup.costPerTrans" [options]="{precision: 4}" [min]="0"
                placeholder=" ">
              <label>Cost Per Transaction</label>
            </div>
            <div class="field">
              <span class="field__prefix">$</span>
              <input currencyMask [(ngModel)]="data.defaultUserMarkup.fixedMonthlyFeeTotal" [options]="{precision: 4}"
                [min]="0" placeholder=" ">
              <label>Fixed Additional Monthly Fees Total</label>
            </div>
          </div>
        </div>

        <!-- Default User Commission -->
        <div class="form-card">
          <div class="form-card__header">
            <span class="form-card__title">Default User Commission</span>
          </div>
          <div class="form-card__body">
            <div class="field">
              <input type="number" step="0.00001" [(ngModel)]="salesCommissPercent"
                [ngModelOptions]="{standalone: true}" [min]="0" placeholder=" ">
              <label>Sales Commission Percent</label>
              <span class="field__suffix">%</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="dialog-actions">
  <button class="cancel-button" type="button" (click)="dialogRef.close()">Cancel</button>
  <button class="save-edit-organization-button" type="button" (click)="save()">Save</button>
</div>